import axios from 'axios';
import baseService from '../shared/baseService';

const spreadsheetService = (userId: number) => baseService(`users/${userId}/spreadsheets`);

const postSpreadsheetFile = (userId: number, params: FormData) => axios.post(`users/${userId}/spreadsheets`, params, {headers: {'Content-Type': 'multipart/form-data'}} );

const getAllByStatus = (userId: number, status: number) => axios.get(`users/${userId}/spreadsheets?status=${status}`);

const getClassifiedSpreadsheet = (userId: number) => axios.get(`users/${userId}/spreadsheets/classified`);

export default {
    spreadsheetService,
    postSpreadsheetFile,
    getAllByStatus,
    getClassifiedSpreadsheet
};